import { useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box } from '@mui/material';
// hooks

// components


import Main from './Main';
import Header from './header';

import NavVertical from './nav/NavVertical';

import { NAV } from '../../config-global';
import Footer from './Footer';

// ----------------------------------------------------------------------

export default function MainLayout() {

    const location = useLocation();
   
    const { masterName } = useParams();
    function formatPageName(pageName) {
        const cleanedPageName = pageName ? pageName.trim().replace(/-/g, ' ') : '';
        const formattedPageName = cleanedPageName.replace(/\b\w/g, char => char.toUpperCase());
        return formattedPageName;
    }
    const headerName = formatPageName(masterName);

    const [open, setOpen] = useState(true);
    const [navWidth, setNavWidth] = useState(NAV.W_DASHBOARD);

   

    

    const handleOpen = () => {
        setOpen(true);
        setNavWidth(NAV.W_DASHBOARD);
    };

    const handleClose = () => {
        setOpen(false);
        setNavWidth(0);
    };

    useEffect(() => { // NOSONAR
        const filteredUrl = JSON.parse(sessionStorage.getItem('filteredUrl'));
        const filterPayload = JSON.parse(sessionStorage.getItem('filterPayload'));
        const gridPageNumber = JSON.parse(sessionStorage.getItem('gridPageNumber'));
        const searchClaimData = JSON.parse(sessionStorage.getItem('searchClaimData'));

        const CAHDetails = JSON.parse(sessionStorage.getItem("CAHDetails"));
        const ClaimSubmissionDetails = JSON.parse(sessionStorage.getItem("ClaimSubmissionDetails"));
        const ClaimClosureHistoryReport = JSON.parse(sessionStorage.getItem("ClaimClosureHistoryReportFilterDetails"));
        const SchemeDefinitionReportFilterState = JSON.parse(sessionStorage.getItem("SchemeDefinitionReportFilterState"));
        
        const claimSummaryReportFilterState = JSON.parse(sessionStorage.getItem("ClaimSummaryReportFilterState"))

        if (claimSummaryReportFilterState && !location.pathname.includes(claimSummaryReportFilterState?.currentUrl)) {
            sessionStorage.removeItem('ClaimSummaryReportFilterState');
        }

        if (CAHDetails && !location.pathname.includes(CAHDetails.currentUrl)) {
            sessionStorage.removeItem('CAHDetails');
        }

        if (ClaimSubmissionDetails && !location.pathname.includes(ClaimSubmissionDetails.currentUrl)) {
            sessionStorage.removeItem('ClaimSubmissionDetails');
        }

        if (SchemeDefinitionReportFilterState && !location.pathname.includes(SchemeDefinitionReportFilterState.currentUrl)) {
            sessionStorage.removeItem('SchemeDefinitionReportFilterState');
        }

        if (ClaimClosureHistoryReport && !location.pathname.includes(ClaimClosureHistoryReport.currentUrl)) {
            sessionStorage.removeItem('ClaimClosureHistoryReportFilterDetails');
        }

        if (filteredUrl && !location.pathname.includes(filteredUrl.currentUrl)) {
            sessionStorage.removeItem('filteredUrl');
        }

        if (filterPayload && !location.pathname.includes(filterPayload.currentUrl)) {
            sessionStorage.removeItem('filterPayload');
            sessionStorage.removeItem('filterValues');
        }

        if (!filterPayload || !location.pathname.includes(filterPayload.currentUrl)) {
            sessionStorage.removeItem('filterValues');
        }

        if (gridPageNumber && !location.pathname.includes(gridPageNumber.currentUrl)) {
            sessionStorage.removeItem('gridPageNumber');
        }

        if (searchClaimData && !location.pathname.includes(searchClaimData.CurrentUrl)) {
            sessionStorage.removeItem('searchClaimData');
        }

        

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    
    return (
        <>
            <Header openNav={open} onOpenNav={handleOpen} navWidth={navWidth} />
            <Helmet>
                <title> {headerName} | ProClaimz </title>
            </Helmet>
            <style>
                {
                    `
           .css-tte4fa-MuiFormHelperText-root{ color : red;}
           .css-icr2t7-MuiFormLabel-root-MuiInputLabel-root.Mui-error {
               color: unset !important;
           }
           .css-1eaco3s-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline{
               border-color: unset !important;
           }
         `
                }
            </style>
            <style>
                {
                    `.css-1s95gw4-MuiButtonBase-root-MuiIconButton-root {padding:0px !important;}
                    `
                }
            </style>
            <Box
                sx={{
                    display: { lg: 'flex' },
                    minHeight: { lg: 1 },
                    height: '100%',
                    flex: 1,

                }}
                style={{ heigth : '100%', flex: 1}}
            >
               
                <NavVertical openNav={open} onOpenNav={handleOpen} onCloseNav={handleClose} navWidth={navWidth} />
                <Main>
                    <Outlet />
                </Main>

            </Box>
            <Footer /> 
        </>
    );
}